const classPrefix = 'contact'
const dataPrefix = 'data-contact'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    contact()
}
export function contact() {

}
